import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "container"]
  static values = { checked: Boolean }

  checkboxClasses = "h-4 w-4 appearance-none border border-gray-300 rounded-sm bg-white checked:bg-blue-500 checked:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 relative checkbox-checkmark"
  labelClasses = "block text-sm font-medium text-gray-700"

  connect() {
    console.log("appstore-additional-checkboxes#connect", this.listTarget.name)

    if (!["#run", "launch", "settings", ""].includes(this.listTarget.value)) {
      this.createCheckbox("checked", this.listTarget.name)
    }
  }

  show(event) {
    console.log(this.listTarget.value)
    if (this.listTarget.value !== "more") {
      return
    }

    const checked = event.params.checked
    const checkedAttr = checked ? "checked" : ""
    this.createCheckbox(checkedAttr, event.params.action)

    // const selectInput = this.listTarget
    // if (selectInput.value !== "more") {
    //   return
    // }
  }

  // @param {string} checkedAttr - "checked" or ""
  // @param {string} name - "fields_inputs[button][run][url]"
  createCheckbox(checkedAttr, name) {
    const action = name.includes("[run]") ? "run" : "install"

    this.containerTarget.innerHTML = `
        <div class="sm:col-span-1">
          <label class="flex items-center mt-2">
            <input type="checkbox" name="fields_inputs[button][${action}][target_blank_off]" ${checkedAttr} value="true" class="${this.checkboxClasses} mr-2">
            <span class="${this.labelClasses}">Przycisk ${action} target blank off</span>
          </label>
        </div>
      `
  }
}
